import {SummarySettlement} from "../summary-settlements.model";
import {GenericDgSearchResults} from "./generic.dg-search-results.model";

export class SummarySettlementsDgSearchResults extends GenericDgSearchResults {
  public results: SummarySettlement[];

  constructor(total: number, results: SummarySettlement[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
